/**
 * @flow
 * @relayHash 3df99faf82b8b985199c6b51440d1750
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AccountProfile_account$ref = any;
export type CreateBankAccountMutationVariables = {|
  accountId: string,
  bsbNumber?: ?string,
  accountNumber?: ?string,
  holderName?: ?string,
  files?: ?$ReadOnlyArray<?any>,
|};
export type CreateBankAccountMutationResponse = {|
  +createBankAccount: ?{|
    +bankAccount: ?{|
      +id: string,
      +bsbNumber: string,
      +accountNumber: string,
      +holderName: string,
      +account: {|
        +$fragmentRefs: AccountProfile_account$ref
      |},
    |}
  |}
|};
export type CreateBankAccountMutation = {|
  variables: CreateBankAccountMutationVariables,
  response: CreateBankAccountMutationResponse,
|};
*/


/*
mutation CreateBankAccountMutation(
  $accountId: ID!
  $bsbNumber: String
  $accountNumber: String
  $holderName: String
  $files: [Upload]
) {
  createBankAccount(accountId: $accountId, bsbNumber: $bsbNumber, accountNumber: $accountNumber, holderName: $holderName, files: $files) {
    bankAccount {
      id
      bsbNumber
      accountNumber
      holderName
      account {
        ...AccountProfile_account
        id
      }
    }
  }
}

fragment AccountProfile_account on AccountNode {
  id
  name
  currentAssets {
    cash {
      actualValueBase
      availableValueBase
      balances {
        currency
        quantity
        availableQuantity
      }
    }
    stock {
      actualValueBase
    }
    fund {
      actualValueBase
    }
  }
  updatedAt
  notes {
    id
  }
  cashwithheldSet {
    edges {
      node {
        id
        amount
        currency
        status
        reason
        createdAt
        updatedAt
      }
    }
  }
  bankAccounts {
    edges {
      node {
        id
        holderName
        bsbNumber
        accountNumber
        status
        dividendPayout
      }
    }
  }
  holdings {
    portfolio {
      id
      trackingVue {
        name
        id
      }
    }
    contract {
      id
      symbol
      name
    }
    quantity
    id
  }
  clientaccount {
    id
    name
    accountStatus
    accountType
    createdAt
    updatedAt
    accruesInterest
    accountSubStatus
    clientaccountprofile {
      createdAt
      updatedAt
      letterOfAuthorityFlag
      protectedPclsFlag
      protectedLsdbaFlag
      id
    }
    nextAllowableStatuses {
      accountStatus
      accountSubStatuses
    }
    currentStatusAllowableSubStatuses
    feeTemplate {
      id
      name
    }
    accountPtr {
      id
      notes {
        id
      }
    }
    adviser {
      id
      email
      firstName
      lastName
      parentTenant {
        name
        id
      }
    }
    tenant {
      id
      name
    }
    referenceNumber
    userModels {
      edges {
        node {
          id
          username
          email
          firstName
          lastName
        }
      }
    }
    activeEmailRecipients {
      id
    }
    tradingApplication {
      id
    }
  }
  tenantaccount {
    name
    accountType
    createdAt
    updatedAt
    tenant {
      id
      name
      email
      firstName
      lastName
      username
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "accountId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "bsbNumber",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "accountNumber",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "holderName",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "files",
    "type": "[Upload]",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  },
  {
    "kind": "Variable",
    "name": "accountNumber",
    "variableName": "accountNumber"
  },
  {
    "kind": "Variable",
    "name": "bsbNumber",
    "variableName": "bsbNumber"
  },
  {
    "kind": "Variable",
    "name": "files",
    "variableName": "files"
  },
  {
    "kind": "Variable",
    "name": "holderName",
    "variableName": "holderName"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "bsbNumber",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "accountNumber",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "holderName",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "actualValueBase",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v10 = [
  (v7/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "updatedAt",
  "args": null,
  "storageKey": null
},
v12 = [
  (v2/*: any*/)
],
v13 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "notes",
  "storageKey": null,
  "args": null,
  "concreteType": "NotesNode",
  "plural": false,
  "selections": (v12/*: any*/)
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v16 = [
  (v6/*: any*/),
  (v2/*: any*/)
],
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "accountStatus",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "accountType",
  "args": null,
  "storageKey": null
},
v19 = [
  (v2/*: any*/),
  (v6/*: any*/)
],
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "username",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateBankAccountMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createBankAccount",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateBankAccountAdmin",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "bankAccount",
            "storageKey": null,
            "args": null,
            "concreteType": "BankAccountNode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "account",
                "storageKey": null,
                "args": null,
                "concreteType": "AccountNode",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "AccountProfile_account",
                    "args": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateBankAccountMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createBankAccount",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateBankAccountAdmin",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "bankAccount",
            "storageKey": null,
            "args": null,
            "concreteType": "BankAccountNode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "account",
                "storageKey": null,
                "args": null,
                "concreteType": "AccountNode",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "currentAssets",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CurrentAssets",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "cash",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CashHoldings",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "availableValueBase",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "balances",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CurrencyBalance",
                            "plural": true,
                            "selections": [
                              (v8/*: any*/),
                              (v9/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "availableQuantity",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "stock",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "StockHoldings",
                        "plural": false,
                        "selections": (v10/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "fund",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FundHoldings",
                        "plural": false,
                        "selections": (v10/*: any*/)
                      }
                    ]
                  },
                  (v11/*: any*/),
                  (v13/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "cashwithheldSet",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CashWithheldNodeConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CashWithheldNodeEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CashWithheldNode",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "amount",
                                "args": null,
                                "storageKey": null
                              },
                              (v8/*: any*/),
                              (v14/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "reason",
                                "args": null,
                                "storageKey": null
                              },
                              (v15/*: any*/),
                              (v11/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "bankAccounts",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BankAccountNodeConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BankAccountNodeEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BankAccountNode",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v5/*: any*/),
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v14/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "dividendPayout",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "holdings",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "HoldingBalanceNode",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "portfolio",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioNode",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "trackingVue",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "VueNode",
                            "plural": false,
                            "selections": (v16/*: any*/)
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "contract",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ContractNode",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "symbol",
                            "args": null,
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ]
                      },
                      (v9/*: any*/),
                      (v2/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "clientaccount",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ClientAccountNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v6/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v15/*: any*/),
                      (v11/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "accruesInterest",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "accountSubStatus",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "clientaccountprofile",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ClientAccountProfileNode",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v11/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "letterOfAuthorityFlag",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "protectedPclsFlag",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "protectedLsdbaFlag",
                            "args": null,
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "nextAllowableStatuses",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ClientAccountStatusAndSubStatus",
                        "plural": true,
                        "selections": [
                          (v17/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "accountSubStatuses",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "currentStatusAllowableSubStatuses",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "feeTemplate",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FeeTemplateNode",
                        "plural": false,
                        "selections": (v19/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "accountPtr",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AccountNode",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v13/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "adviser",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AdviserNode",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "parentTenant",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TenantNode",
                            "plural": false,
                            "selections": (v16/*: any*/)
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tenant",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TenantNode",
                        "plural": false,
                        "selections": (v19/*: any*/)
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "referenceNumber",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "userModels",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserModelNodeConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserModelNodeEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UserModelNode",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v23/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "activeEmailRecipients",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserModelNode",
                        "plural": true,
                        "selections": (v12/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradingApplication",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradingApplicationNode",
                        "plural": false,
                        "selections": (v12/*: any*/)
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "tenantaccount",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TenantAccountNode",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v18/*: any*/),
                      (v15/*: any*/),
                      (v11/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tenant",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TenantNode",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v6/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/)
                        ]
                      },
                      (v2/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateBankAccountMutation",
    "id": null,
    "text": "mutation CreateBankAccountMutation(\n  $accountId: ID!\n  $bsbNumber: String\n  $accountNumber: String\n  $holderName: String\n  $files: [Upload]\n) {\n  createBankAccount(accountId: $accountId, bsbNumber: $bsbNumber, accountNumber: $accountNumber, holderName: $holderName, files: $files) {\n    bankAccount {\n      id\n      bsbNumber\n      accountNumber\n      holderName\n      account {\n        ...AccountProfile_account\n        id\n      }\n    }\n  }\n}\n\nfragment AccountProfile_account on AccountNode {\n  id\n  name\n  currentAssets {\n    cash {\n      actualValueBase\n      availableValueBase\n      balances {\n        currency\n        quantity\n        availableQuantity\n      }\n    }\n    stock {\n      actualValueBase\n    }\n    fund {\n      actualValueBase\n    }\n  }\n  updatedAt\n  notes {\n    id\n  }\n  cashwithheldSet {\n    edges {\n      node {\n        id\n        amount\n        currency\n        status\n        reason\n        createdAt\n        updatedAt\n      }\n    }\n  }\n  bankAccounts {\n    edges {\n      node {\n        id\n        holderName\n        bsbNumber\n        accountNumber\n        status\n        dividendPayout\n      }\n    }\n  }\n  holdings {\n    portfolio {\n      id\n      trackingVue {\n        name\n        id\n      }\n    }\n    contract {\n      id\n      symbol\n      name\n    }\n    quantity\n    id\n  }\n  clientaccount {\n    id\n    name\n    accountStatus\n    accountType\n    createdAt\n    updatedAt\n    accruesInterest\n    accountSubStatus\n    clientaccountprofile {\n      createdAt\n      updatedAt\n      letterOfAuthorityFlag\n      protectedPclsFlag\n      protectedLsdbaFlag\n      id\n    }\n    nextAllowableStatuses {\n      accountStatus\n      accountSubStatuses\n    }\n    currentStatusAllowableSubStatuses\n    feeTemplate {\n      id\n      name\n    }\n    accountPtr {\n      id\n      notes {\n        id\n      }\n    }\n    adviser {\n      id\n      email\n      firstName\n      lastName\n      parentTenant {\n        name\n        id\n      }\n    }\n    tenant {\n      id\n      name\n    }\n    referenceNumber\n    userModels {\n      edges {\n        node {\n          id\n          username\n          email\n          firstName\n          lastName\n        }\n      }\n    }\n    activeEmailRecipients {\n      id\n    }\n    tradingApplication {\n      id\n    }\n  }\n  tenantaccount {\n    name\n    accountType\n    createdAt\n    updatedAt\n    tenant {\n      id\n      name\n      email\n      firstName\n      lastName\n      username\n    }\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c4d6bfe624d26f231f30f1a888d5b710';
module.exports = node;
